import { useContext } from "react";
import useSWR from "swr";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { ToastContext } from "../context/ToastContext";
import { TaskModel } from "@attelas/shared";

export const useSuggestedActions = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<TaskModel[]>(
    `${environment.apiUrl}/api/payables/tasks`,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to get suggested actions, please try again later", "error");
      },
    }
  );

  return {
    actions: data,
    isLoading,
    isError: !!error,
  };
};
